import * as React from 'react';

import type { ToggleTabValue } from 'bundles/cds-labs/components/ToggleTab/types';

interface ToggleTabContextStateType {
  value: ToggleTabValue;
  id: string;
  invert: boolean;
  onChange: (value: ToggleTabValue) => void;
  registerTabRef: (value: ToggleTabValue, ref: React.RefObject<HTMLButtonElement>) => void;
  updateIndicatorPosition: () => void;
  indicatorStyle: { width: number; left: number };
}

export const ToggleTabStateContext = React.createContext<ToggleTabContextStateType | undefined>(undefined);

export const useToggleTabContext = () => {
  const context = React.useContext(ToggleTabStateContext);
  if (!context) {
    throw new Error('useToggleTab must be used within a ToggleTabContext');
  }

  return context;
};
